const tooltips = {
  kep: 'Minden olyan kép feltölthető, ami nem átlátszó (nincs alfa csatornája). Például: JPG/JPEG, BMP többsége, GIF többsége, AVIF',
};

export default function getTooltip(name) {
  return tooltips[name];
}
